import { Space, Tag, Dropdown, Menu } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import {
  BTN_TXT,
  ROLE_IDS,
  ROLE_STYLES,
  GLOBAL_CONSTANTS,
  isRootUser,
} from "../../../../constants/constants";
import { capitalizeWords } from "../../../../helpers/helpers";
import { safeIdSort, safeStringSort } from "../../../../helpers/sortHelpers";

export const getUserColumns = ({
  onView,
  onEdit,
  onDeactivate,
  onResetPassword,
  onResetMfa,
  canResetMfa = false,
} = {}) => [
  {
    title: "User ID",
    dataIndex: "userId",
    key: "userId",
    width: 150,
    sorter: (a, b) => safeIdSort(a?.userId, b?.userId),
  },
  {
    title: "User Name",
    dataIndex: "userName",
    key: "userName",
    width: 250,
    sorter: (a, b) => safeStringSort(a?.userName, b?.userName),
  },
  {
    title: "Organization",
    dataIndex: "busName",
    key: "busName",
    width: 300,
    sorter: (a, b) => safeStringSort(a?.busName, b?.busName),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 250,
  },
  {
    title: "User Role",
    dataIndex: "roleName",
    key: "roleName",
    render: (roleName) => <Tag style={ROLE_STYLES[roleName]}>{capitalizeWords(roleName)}</Tag>,
  },
  {
    title: "Status",
    dataIndex: "statusName",
    key: "statusName",
    width: 220,
    render: (statusName, record) => {
      const dealCategories = record?.dealCategories;
      if (Array.isArray(dealCategories) && dealCategories.length > 0) {
        return (
          <Space direction="vertical" size={4}>
            {dealCategories.map((category) => (
              <div key={category.dealCategoryId || category.dealCategoryName}>
                {category.dealCategoryName || GLOBAL_CONSTANTS.NA}
                {" → "}
                {category.statusName || GLOBAL_CONSTANTS.NA}
              </div>
            ))}
          </Space>
        );
      }
      return statusName || GLOBAL_CONSTANTS.NA;
    },
  },
  {
    title: "Actions",
    key: "actions",
    fixed: "right",
    width: 80,
    render: (_, record) => {
      const hasRestrictedRole =
        record?.roleId === ROLE_IDS.BUS_ROLE_ID ||
        record?.roleId === ROLE_IDS.INV_ROLE_ID;
      const isProtectedRoot = isRootUser(record);
      const canModify = !hasRestrictedRole && !isProtectedRoot;
      const isDeactivated = record?.statusName === "DEACTIVATED";
      const isActive = record?.statusName === "ACTIVE";
      const showResetMfa = canResetMfa && record?.totpEnabled && !isProtectedRoot;
      const showResetPassword =
        record?.roleId === ROLE_IDS.BUS_ROLE_ID && !isActive && !isDeactivated;

      const menuItems = [
        {
          key: "view",
          label: BTN_TXT.VIEW,
          onClick: () => onView?.(record.userId),
        },
      ];

      if (canModify) {
        menuItems.push({
          key: "edit",
          label: BTN_TXT.EDIT,
          onClick: () => onEdit?.(record.userId),
        });
      }

      if (showResetPassword) {
        menuItems.push({
          key: "resetPassword",
          label: "Reset Temp Password",
          onClick: () => onResetPassword?.(record.userId),
        });
      }

      if (showResetMfa) {
        menuItems.push({
          key: "resetMfa",
          label: BTN_TXT.RESET_MFA,
          onClick: () => onResetMfa?.(record.userId, record.userName),
        });
      }

      if (canModify && !isDeactivated) {
        menuItems.push({
          key: "deactivate",
          label: BTN_TXT.DEACTIVATE,
          onClick: () => onDeactivate?.(record),
        });
      }

      return (
        <Dropdown
          menu={{ items: menuItems }}
          overlay={<Menu items={menuItems} />}
          trigger={["click"]}
        >
          <MoreOutlined style={{ fontSize: "18px", cursor: "pointer" }} />
        </Dropdown>
      );
    },
  },
];
